import { Play } from "../../Common/SI"

export default class Filtering {

	public static keys: FilterKey[] = [
		'adversaries',
		'aspects',
		'blightCards',
		'dateRange',
		'difficulties',
		'islandStates',
		'layouts',
		'locations',
		'outcomes',
		'outcomeTypes',
		'players',
		'playersAsSpirits',
		'spirits',
		'spiritCounts',
		'turns',
	]

	public static canChangeType(key: FilterKey): boolean {
		return ['blightCards', 'dateRange', 'difficulties', 'islandStates', 'layouts', 'locations', 'outcomes', 'spiritCounts', 'turns'].indexOf(key) === -1
	}

	public static filterPlays = (allPlays: Play[], filters: Filter[]): Play[] => {
		const plays = []

		for (const play of allPlays) {
			let include = true

			include = include && Filtering.applyFilter(filters.find(f => f.key === 'adversaries'), play.adversaries.map(a => a.name))

			include = include && Filtering.applyFilter(filters.find(f => f.key === 'aspects'), play.spirits.map(s => s.aspect || ''))

			include = include && Filtering.applyFilter(filters.find(f => f.key === 'blightCards'), play.islandState ? play.islandState.blightCards : [])

			include = include && Filtering.applyFilter(filters.find(f => f.key === 'difficulties'), [`${play.difficulty}`])

			include = include && Filtering.applyFilter(filters.find(f => f.key === 'islandStates'), [!play.islandState ? 'Unknown' : play.islandState.healthy ? 'Healthy' : 'Blighted'])

			include = include && Filtering.applyFilter(filters.find(f => f.key === 'layouts'), [`${play.layout}`])

			include = include && Filtering.applyFilter(filters.find(f => f.key === 'locations'), [`${play.location}`])

			include = include && Filtering.applyFilter(filters.find(f => f.key === 'outcomes'), [play.outcome.victory ? 'Victory' : 'Loss'])

			include = include && Filtering.applyFilter(filters.find(f => f.key === 'outcomeTypes'), [play.outcome.type])

			include = include && Filtering.applyFilter(filters.find(f => f.key === 'players'), play.players.map(p => p.name))

			include = include && Filtering.applyFilter(filters.find(f => f.key === 'playersAsSpirits'), play.spirits.map(playedSpirit => `${playedSpirit.player.name} as ${playedSpirit.spirit.nickname}`))

			include = include && Filtering.applyFilter(filters.find(f => f.key === 'spirits'), play.spirits.map(s => s.spirit.name))

			include = include && Filtering.applyFilter(filters.find(f => f.key === 'spiritCounts'), [`${play.spirits.length}`])

			include = include && Filtering.applyFilter(filters.find(f => f.key === 'turns'), [`${play.turns}`])

			if (include) {
				const dateRangeFilter = filters.find(f => f.key === 'dateRange')
				if (dateRangeFilter) {
					include = play.dateTimeString >= dateRangeFilter.values[0] && play.dateTimeString.substring(0, 10) <= dateRangeFilter.values[1]
				}
			}

			if (include) {
				plays.push(play)
			}
		}

		return plays
	}

	public static initialType = (filterKey: FilterKey) => {
		return ['players', 'spirits'].indexOf(filterKey) !== -1 ? 'all' : 'any'
	}

	private static applyFilter = (filter: Filter | undefined, playValues: string[]): boolean => {
		if (!filter) {
			return true
		}

		switch (filter.type) {
			case 'all':
				for (const value of filter.values) {
					if (playValues.indexOf(value) === -1) {
						return false
					}
				}
				return true

			case 'any':
				for (const value of filter.values) {
					if (playValues.indexOf(value) > -1) {
						return true
					}
				}
				return false

			case 'exact':
				for (const value of filter.values) {
					if (playValues.indexOf(value) === -1) {
						return false
					}
				}
				for (const value of playValues) {
					if (filter.values.indexOf(value) === -1) {
						return false
					}
				}
				return true
		}
	}
}

export interface Filter {
	canChangeType: boolean
	key: FilterKey
	values: string[]
	type: FilterType
}

export type FilterType = 'all' | 'any' | 'exact'

export type FilterKey =
	'adversaries'
	| 'aspects'
	| 'blightCards'
	| 'dateRange'
	| 'difficulties'
	| 'islandStates'
	| 'layouts'
	| 'locations'
	| 'outcomes'
	| 'outcomeTypes'
	| 'players'
	| 'playersAsSpirits'
	| 'spirits'
	| 'spiritCounts'
	| 'turns'
